import { AtlasObjectType } from '@common/helpers/atlasUrls'

/** What each kind of Atlas record is called above its name, in its preview card and module panel. */
export const ATLAS_OBJECT_TYPE_LABELS: Record<AtlasObjectType, string> = {
  [AtlasObjectType.Task]: 'Task',
  [AtlasObjectType.Person]: 'Person',
  [AtlasObjectType.Client]: 'Client',
  [AtlasObjectType.Prospect]: 'Prospect',
  [AtlasObjectType.BBC]: 'Borrowing base',
  [AtlasObjectType.Organization]: 'Organization',
  [AtlasObjectType.Entity]: 'Entity',
  [AtlasObjectType.Company]: 'Company',
  [AtlasObjectType.OngoingReporting]: 'Ongoing reporting',
  [AtlasObjectType.TaskProject]: 'Project',
  [AtlasObjectType.Participant]: 'Participant',
  [AtlasObjectType.DueDiligence]: 'Due diligence',
  [AtlasObjectType.User]: 'Teammate',
}
